import React, { useState, useEffect } from "react";
import DraftAssessBoxHW from "./DraftAssessBoxHW";
import axios from "../../../../../axios";
import NoResponse from "../../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
import DeleteConfirmation from "../../Published/Published_Q_list/PublishQuestionType/DeleteConfirmation/DeleteConfirmation";

const DraftAssessPropsBoxHW = ({ filter }) => {
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const TeacherId = localStorage.getItem("Teacher_id");
  const jsonTeacherId = JSON.parse(TeacherId);
  const [isGettingData, setIsGettingData] = useState(true);
  const [publishhw, setPublishHW] = useState([]);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [noresponse, setNoresponse] = useState(false);
  const [hwId, setHwId] = useState(null);
  const timeHelper = (a) => {
    const inputDateString = a;
    const dateObj = new Date(inputDateString);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  const timeHelper1 = (a) => {
    const dateString = a;
    const dateObj = new Date(dateString);
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const amOrPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    const timeString = formattedHours + ":" + formattedMinutes + " " + amOrPm;
    return timeString;
  };
  const onCancel = () => {
    setDeleteConfirmation(false);
  };
  const handleDelete = () => {
    axios
      .delete(`/api/v1/homework/delete/${hwId}`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          teacher_id: jsonTeacherId,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          window.location.reload();
        }
        console.log(response);
      });
  };
  useEffect(() => {
    const getPublishedRes = async () => {
      try {
        let helper = [];
        let response = await axios.get(
          `/api/v1/homework/filterByTeacherId/${Teacher_Json}/draft?_page=1&academic_session_id=${academicSessionId}&timetable_session_id=${timeTableSessionId}` +
            `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
            `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
            `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
            `&${filter?.date && `date=${filter?.date}`}` +
            `&${filter?.time && `time=${filter?.time}`}` +
            `&${
              filter?.subjectId?.length !== 0 &&
              `subjectId=${filter?.subjectId}`
            }`,
        );
        if (response?.data?.data.length === 0) {
          helper = [];
          setPublishHW([]);
          setNoresponse(true);
        }
        response?.data?.data.forEach((obj) => {
          let res = {
            id: obj?.id,
            section: `${obj?.section_id?.name}`,
            standard: `${obj?.standard_id?.name}`,
            published_subject: `${obj?.subject_id.name}`,
            published_assessName: `${obj?.name}`,
            updated_date: timeHelper(obj?.updated_at),
            updated_time: timeHelper1(obj?.updated_at),
            Published_response: "91",
          };
          helper.push(res);
          setPublishHW(helper);
        });
      } catch (e) {
        console.log(e);
      } finally {
        setIsGettingData(false);
      }
    };
    getPublishedRes();
  }, [filter]);
  return publishhw && publishhw.length > 0 ? (
    <div className="container">
      <div className="row">
        {publishhw.map((obj) => (
          <div key={obj.id} className="col-md-3 d-flex mb-3">
            <DraftAssessBoxHW
              id={`${obj.id}`}
              section={`${obj?.section}`}
              standard={`${obj?.standard}`}
              Draft_subject={`${obj.published_subject}`}
              Draft_assessName={`${obj.published_assessName}`}
              updated_date={`${obj.updated_date}`}
              updated_time={`${obj.updated_time}`}
              setDeleteConfirmation1={setDeleteConfirmation}
              setHwId1={setHwId}
            />
          </div>
        ))}
        {deleteConfirmation && (
          <DeleteConfirmation onConfirm={handleDelete} onCancel={onCancel} />
        )}
      </div>
    </div>
  ) : // (
  //   <>
  //   <img
  //       className="publishAccessLoader"
  //       src="/gift/black loader.gif"
  //       alt=""
  //     />
  //     {noresponse && !deleteConfirmation && <NoResponse setNoresponse={setNoresponse} />}
  //   </>
  // )
  isGettingData ? (
    <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
  ) : (
    <div className="d-flex justify-content-center align-items-center w-100">
      <span
        className="px-2 py-2 d-flex align-items-center gap-2"
        style={{ fontSize: "1.2rem", fontWeight: 500 }}
      >
        ✏️ Homework Not Found
      </span>
    </div>
  );
};

export default DraftAssessPropsBoxHW;
